import { getJson } from './client';

export interface UserSelfData {
  id: number;
  username: string;
  display_name?: string;
  quota?: number | null;
  [key: string]: unknown;
}

export interface UserSelfResponse {
  success: boolean;
  message: string;
  data: UserSelfData | null;
  [key: string]: unknown;
}

export const fetchUserSelf = async (): Promise<UserSelfResponse> => {
  return getJson<UserSelfResponse>('/api/workers-proxy/user-self', {
    resolveEndpoint: false,
    cache: 'no-store',
  });
};

